import { object, string } from "superstruct";

import RouteNavigator from "@mpa/toolbox/navigation/Navigator";
import Route from "@mpa/toolbox/navigation/Route";

import { loggedInNavigator } from "../../navigation/routes";

export const contactsNavigator = loggedInNavigator.addNavigator(
    new RouteNavigator().setPath("/contacts"),
);
export const contactsRoute = contactsNavigator.addRoute(new Route());
export const newContactsRoute = contactsNavigator.addRoute(new Route().setPath("/new"));
export const candidateRoute = contactsNavigator.addRoute(
    new Route().setPath("/candidates/:user", object({ user: string() })),
);
export const invitationRoute = contactsNavigator.addRoute(new Route().setPath("/invitation"));
export const invitationCodeRoute = contactsNavigator.addRoute(
    new Route().setPath("/invitation/:joinSession", object({ joinSession: string() })),
);
export const contactRoute = contactsNavigator.addRoute(
    new Route().setPath("/:contact", object({ contact: string() })),
);
